import Fetcher from './modules/fetcher';
import More from './modules/more';
import HorizontalScroll from './modules/horizontal-scroll';

// Lightbox
Array.from(document.querySelectorAll("[data-lightbox]")).forEach(element => {
  element.onclick = (e) => {
    e.preventDefault();
    // TODO may useligthbox from kobin tischlerei
    basicLightbox.create(`<img src="${element.href}">`).show();
  };
});

Fetcher.init()
More.init()
HorizontalScroll.init()
